import ApiServices from "@/services/ApiServices";

export default {
  data: function () {
    return {};
  },
  methods: {
    // using the lens id, gets data from the autocomplete
    // the same data that would be returned by the searchall autocomplete function - just allows us to set this externally
    // second parameter is the function to call (in the parent) with the result
    summaryForId(id, methodToCall) {
      this.loading = true;
      //   let that = this;
      ApiServices.summaryForItemId(id)
        .then((response) => {
          let result = response.data;
          if (result.itemId) this[methodToCall](result);
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
  },
  computed: {},
  mounted() {},
};
